module.exports = __webpack_public_path__ + "img/erweima.3aeeec8d.png";